import React from "react";
import { Form, Button, Icon, Notification } from "react-bulma-components/full";
import { Redirect, Link } from "react-router-dom";
import to from "await-to-js";
import "./Signin.scss";
import Auth from "../services/Auth";
import LocaleContext from "../context/LocaleContext";
import { isDisposableEmail } from "../services/Utils";

export default class ResetPassword extends React.Component {
  initialState = () => ({
    email: "",
    isResetLoad: false,
    resetError: null,
  });

  constructor(props) {
    super(props);
    this.state = this.initialState();
  }
  static contextType = LocaleContext;
  handleChangeInput = ({ target }) => {
    this.setState({ [target.name]: target.value });
  };

  _setResetState = (message) => {
    this.setState({
      resetError: message,
      isResetLoad: false,
    });
  };

  handleResetPassword = async (e) => {
    e.preventDefault();
    const { email } = this.state;
    const trimmedEmail = email.trim();

    this.setState({ isResetLoad: true });

    const isDisposable = await isDisposableEmail(trimmedEmail);
    if (isDisposable) {
      return this._setResetState("Cette adresse email n'est pas valide.");
    }

    const [err] = await to(Auth.isEmailUsed(trimmedEmail));
    console.log("🚀 ~ ResetPassword ~ err:", err);

    if (!err) {
      Auth.resetPassword(trimmedEmail);
      return this._setResetState(
        "Aucun compte n'est associé à cette adresse email, veuillez réessayer.",
      );
    }

    if (err?.message === "email-already-in-use") {
      Auth.resetPassword(trimmedEmail);
      return this._setResetState(
        "Nous venons de vous envoyer un email vous permettant de réinitialiser votre mot de passe",
      );
    }

    return this._setResetState(
      "Une erreur est survenue, veuillez réessayer plus tard.",
    );
  };

  _setResetState = (message) => {
    this.setState({
      resetError: message,
      isResetLoad: false,
    });
  };

  renderErrorNotification = () => {
    const { resetError } = this.state;

    if (resetError == null) return;

    return (
      <Notification
        color={
          resetError ===
          "Nous venons de vous envoyer un email vous permettant de réinitialiser votre mot de passe"
            ? "info"
            : "danger"
        }
      >
        <>{resetError}</>
      </Notification>
    );
  };

  render() {
    const { email, isResetLoad } = this.state;

    return (
      <div className="signin-wrapper container is-centered">
        {/* {this.renderBrowserWarning()} */}

        <div className="columns">
          <div className="column is-half is-offset-one-quarter">
            <div className="box">
              <div className="subtitle is-4">Mot de passe oublié</div>
              {/* {this.renderErrorNotification()} */}
              <form onSubmit={this.handleResetPassword}>
                {this.renderErrorNotification()}
                <Form.Field>
                  <Form.Label>Renseignez votre email</Form.Label>
                  <Form.Control iconLeft>
                    <Form.Input
                      placeholder="Exemple: hello@domain.com"
                      type="email"
                      value={email}
                      name="email"
                      onChange={this.handleChangeInput}
                    />
                    <Icon align="left">
                      <i className="fa fa-envelope" />
                    </Icon>
                  </Form.Control>

                  <Form.Field className="has-text-centered">
                    <Form.Control>
                      <Button
                        loading={isResetLoad}
                        disabled={isResetLoad || !email}
                        color="info"
                        type="primary"
                        style={{ marginTop: "20px" }}
                      >
                        Réinitialiser le mot de passe
                      </Button>
                    </Form.Control>
                  </Form.Field>
                </Form.Field>
              </form>
            </div>
            <div className="has-text-centered">
              <Link to="/signin">Retour à la connexion</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
